import AttributeValues from "./AttributeValues";

export const birthDateOverrideString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate/";
export const genderOverrideString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender/";
export const multipleBirthBooleanOverrideString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator/";
export const genericOverrideURL =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override";
export const phoneAreaString =
  "http://hl7.org/fhir/StructureDefinition/contactpoint-area";
export const phonePhExchangeString =
  "http://hl7.org/fhir/StructureDefinition/contactpoint-phExchange";
export const phonePhNumberString =
  "http://hl7.org/fhir/StructureDefinition/contactpoint-phNumber";
export const phoneCountryString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#contactpoint-phStdInd";
export const addressSrcTimeStampString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#address-srcTmStmp";
export const attrCodeString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/imdm/#attrCode";
export const overriddenByString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-updatedBy";
export const overrideReasonString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-reason";
export const overrideTimestampString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#override-timestamp";
export const dobOverriddenByString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-updatedBy";
export const dobOverrideReasonString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-reason";
export const dobOverrideTimestampString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideBirthDate-timestamp";
export const genderOverriddenByString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-updatedBy";
export const genderOverrideReasonString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-reason";
export const genderOverrideTimestampString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideGender-timestamp";
export const multipleBirthOverriddenByString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-updatedBy";
export const multipleBirthOverrideReasonString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-reason";
export const multipleBirthOverrideTimestampString =
  "https://github.optum.com/pages/HealthcareMatching/hcm-microsite/fhir-extensions/#overrideMultipleBirthIndicator-timestamp";

export const getValueTypeByAttribute = attribute => {
  switch (attribute) {
    case "name":
      return "valueHumanName";
    case "address":
      return "valueAddress";
    case "telecom":
      return "valueContactPoint";
    case "identifier":
      return "valueIdentifier";
    case "gender":
      return "valueString";
    case "birthDate":
      return "valueDate";
    case "multipleBirthBoolean":
      return "valueBoolean";
    case "phone":
      return "valueContactPoint";
    case "email":
      return "valueContactPoint";
    default:
      return "valueString";
  }
};

export const SelectedPrimaryRecords = (records, primaryRecords) => {
  return records.filter(r =>
    primaryRecords.find(
      pr => pr.recordId === r.id && pr.source === r.meta.source
    )
  );
};

export const recordHasOverride = record => {
  const overrideStrings = [
    birthDateOverrideString,
    genderOverrideString,
    genericOverrideURL
  ];
  return overrideStrings.some(str => JSON.stringify(record).includes(str));
};

export const isEquivalentValue = (val1, val2, attribute) => {
  if (typeof val1 === "string" && typeof val2 === "string") {
    return attribute === "identifier"
      ? val1 === val2
      : val1.toUpperCase() === val2.toUpperCase();
  }
  return false;
};

export const inactivateObject = obj => {
  const inactiveObj = { ...obj };

  delete inactiveObj["extension"];
  inactiveObj["use"] = "old";

  return inactiveObj;
};

export const RecordsToOverride = (
  attributeValues,
  attribute,
  system,
  attrCode,
  action,
  incorrectValue,
  code
) => {
  var returnList = attributeValues.flat();

  switch (attribute) {
    case "birthDate":
    case "gender":
      if (action === "replace") {
        return (returnList = returnList.filter(
          v =>
            isEquivalentValue(
              v.get("displayValue"),
              incorrectValue,
              attribute
            ) && !v.get("overridePresent")
        ));
      }
      break;

    case "identifier":
      if (action === "replace" || action === "inactive") {
        if (typeof code !== "undefined" && code !== "") {
          return returnList.filter(
            v =>
              v.get("code") === code &&
              isEquivalentValue(
                v.get("displayValue"),
                incorrectValue,
                attribute
              ) &&
              !v.has("system") &&
              v.get("use") !== "old" &&
              !v.get("overridePresent")
          );
        } else {
          return returnList.filter(
            v =>
              v.get("system") === system &&
              isEquivalentValue(
                v.get("displayValue"),
                incorrectValue,
                attribute
              ) &&
              v.get("use") !== "old" &&
              !v.get("overridePresent")
          );
        }
      } else if (action === "invalid") {
        if (typeof code !== "undefined" && code !== "") {
          return returnList.filter(
            v =>
              v.get("code") === code &&
              isEquivalentValue(
                v.get("displayValue"),
                incorrectValue,
                attribute
              ) &&
              !v.has("system") &&
              !v.get("overridePresent")
          );
        } else {
          return returnList.filter(
            v =>
              v.get("system") === system &&
              isEquivalentValue(
                v.get("displayValue"),
                incorrectValue,
                attribute
              ) &&
              !v.get("overridePresent")
          );
        }
      }
      break;

    case "address":
    case "name":
    case "phone":
    case "email":
      if (action === "replace" || action === "inactive") {
        return returnList.filter(
          v =>
            v.get("attrCode") === attrCode &&
            isEquivalentValue(
              v.get("displayValue"),
              incorrectValue,
              attribute
            ) &&
            v.get("use") !== "old" &&
            !v.get("overridePresent")
        );
      } else if (action === "invalid") {
        return returnList.filter(
          v =>
            v.get("attrCode") === attrCode &&
            isEquivalentValue(
              v.get("displayValue"),
              incorrectValue,
              attribute
            ) &&
            !v.get("overridePresent")
        );
      }
      break;
  }
};
